import SiteFooter from './SiteFooter.jsx'

export default function PolicyLayout({
  children,
  effectiveDate,
  footerNote,
  label,
  title,
  toc,
}) {
  return (
    <>
      <main id="main-content" className="policy-layout">
        <aside className="policy-sidebar" aria-label="Policy summary and sections">
          <span className="policy-meta">{label}</span>
          <h1>{title}</h1>
          <div className="effective-date">Effective {effectiveDate}</div>
          <nav className="policy-toc" aria-label="Policy sections">
            {toc.map((item) => (
              <a href={`#${item.id}`} key={item.id}>
                {item.label}
              </a>
            ))}
          </nav>
        </aside>
        <article className="policy-article">{children}</article>
      </main>
      <SiteFooter note={footerNote} />
    </>
  )
}
